//Parroquia Sucre
const munAndrésEloyBlancoSucre = ['Mariño', 'Rómulo Gallegos'];
const munAndrésMata = ['San José de Aerocuar', 'Tavera Acosta'];
const munArismendiSucre = [
  'Río Caribe',
  'Antonio José de Sucre',
  'El Morro de Puerto Santo',
  'Puerto Santo',
  'San Juan de Las Galdonas',
];
const munBenítez = [
  'El Pilar',
  'El Rincón',
  'General Francisco Antonio Vásquez',
  'Guaraúnos',
  'Tunapuicito',
  'Unión',
];
const munBermúdez = [
  'Bolívar',
  'Macarapana',
  'Santa Catalina',
  'Santa Rosa',
  'Santa Teresa',
];
const munBolívarSucre = ['Bolívar'];
const munCajigal = ['Yaguaraparo', 'El Paujil', 'Libertad'];
const munCruzSalmerónAcosta = ['Araya', 'Chacopata', 'Manicuare'];
const munLibertadorSucre = ['Tunapuy', 'Campo Elías'];
const munMariñoSucre = [
  'Irapa',
  'Campo Claro',
  'Marabal',
  'San Antonio de Irapa',
  'Soro',
];
const munMejía = ['Mejía'];
const munMontes = [
  'Cumanacoa',
  'Arenas',
  'Aricagua',
  'Cocollar',
  'San Fernando ',
  'San Lorenzo',
];
const munRibero = [
  'Cariaco',
  'Catuaro ',
  'Rendón',
  'Santa Cruz',
  'Santa María',
];
const munSucreSucre = [
  'Altagracia',
  'Ayacucho',
  'Santa Inés',
  'Valentín Valiente',
  'San Juan',
  'Raúl Leoni',
  'Gran Mariscal',
];
const munValdez = ['Güiria', 'Bideau', 'Cristóbal Colón', 'Punta de Piedras'];

export const esSucre = [
  {
    municipio: 'Andrés Eloy Blanco',
    parroquias: munAndrésEloyBlancoSucre,
  },
  {
    municipio: 'Andrés Mata',
    parroquias: munAndrésMata,
  },
  {
    municipio: 'Arismendi',
    parroquias: munArismendiSucre,
  },
  {
    municipio: 'Benítez',
    parroquias: munBenítez,
  },
  {
    municipio: 'Bermúdez',
    parroquias: munBermúdez,
  },
  {
    municipio: 'Bolívar',
    parroquias: munBolívarSucre,
  },
  {
    municipio: 'Cajigal',
    parroquias: munCajigal,
  },
  {
    municipio: 'Cruz Salmerón Acosta',
    parroquias: munCruzSalmerónAcosta,
  },
  {
    municipio: 'Libertador',
    parroquias: munLibertadorSucre,
  },
  {
    municipio: 'Mariño',
    parroquias: munMariñoSucre,
  },
  {
    municipio: 'Mejía',
    parroquias: munMejía,
  },
  {
    municipio: 'Montes',
    parroquias: munMontes,
  },
  {
    municipio: 'Ribero',
    parroquias: munRibero,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucreSucre,
  },
  {
    municipio: 'Valdez',
    parroquias: munValdez,
  },
];
